export default __webpack_public_path__ + "static/media/icon-delete.72d56983.svg";